const PRODUCT_TYPES = {
  ALL: 'all',
  BEVERAGE: 'beverage',
  DISH: 'dish'
};

export default PRODUCT_TYPES;
